var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLivestream = function SvgLivestream(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "07.-Minc-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Menu",
    transform: "translate(-940.000000, -550.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Navigation-Bar-/-Telefit",
    transform: "translate(920.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Telefit-List",
    transform: "translate(0.000000, 417.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(0.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,14.5 L17,11 C17,10.45 16.55,10 16,10 L4,10 C3.45,10 3,10.45 3,11 L3,21 C3,21.55 3.45,22 4,22 L16,22 C16.55,22 17,21.55 17,21 L17,17.5 L21,21.5 L21,10.5 L17,14.5 Z M8.37555276,13 C8.47515555,13 8.57067886,13.0248328 8.64110867,13.0690356 L12.7800063,15.6666667 C13.0733312,15.8507616 13.0733312,16.1492384 12.7800063,16.3333333 L8.64110867,18.9309644 C8.49444619,19.0230119 8.25665933,19.0230119 8.10999686,18.9309644 C8.03956705,18.8867617 8,18.8268099 8,18.7642977 L8,13.2357023 C8,13.1055275 8.1681407,13 8.37555276,13 Z M7.5,8 C7.77614237,8 8,8.22385763 8,8.5 L8,10 L6,10 L6,8.5 C6,8.22385763 6.22385763,8 6.5,8 L7.5,8 Z",
    id: "Combined-Shape",
    fill: "#F6F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2,4.9 L12,4.1 C10.6,2.7 8.8,2 7,2 C5.2,2 3.4,2.7 2,4.1 L2.8,4.9 C4,3.8 5.5,3.2 7,3.2 C8.5,3.2 10,3.8 11.2,4.9 Z",
    id: "Path",
    fill: "#F6F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3,5.7 C9.4,4.8 8.2,4.3 7,4.3 C5.8,4.3 4.6,4.8 3.7,5.7 L4.5,6.5 C5.2,5.8 6.1,5.5 7,5.5 C7.9,5.5 8.8,5.8 9.5,6.5 L10.3,5.7 L10.3,5.7 Z",
    id: "Path",
    fill: "#F6F7FA"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLivestream, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/livestream.e46666e3.svg";
export { ForwardRef as ReactComponent };